// Map Each Page from State Field to Form Fill Field
module.exports = {
    page1: {
        description: "Opening Intro Slide",
        action: "MailMerge",
        template: "front_page.pdf",
        font: "opensans",
        page: 'page1.pdf',
        fields: [
            { index:  null, state:  "full_name", pdf: "full_name", format: 'Uppercase', title: 'N'},
            { index:  null, state:  "address", pdf: "address", format: 'Uppercase', title: 'N'}
        ]
    },
    page2: { description: "About WOS….It's nice to know…..", action: 'TemplatePage', template: 'page2.pdf'},
    page3: { description: "What our customer say 1", action: 'TemplatePage', template: 'page3.pdf'},
    page4: { description: "What our customer say 2", action: 'TemplatePage', template: 'page4.pdf'},
    page5: { description: "What our customer say 3", action: 'TemplatePage', template: 'page5.pdf'},
    page6: { description: "What our customer say 4", action: 'TemplatePage', template: 'page6.pdf'},
    page7: { description: "What our customer say 5", action: 'TemplatePage', template: 'page7.pdf'},
    page8: { description: "Happy roofs  - Images", action: 'TemplatePage', template: 'page8.pdf'},
    page9: { description: "Happy Hardware - Images", action: 'TemplatePage', template: 'page9.pdf'},
    page10: { description: "The story so far", action: 'TemplatePage', template: 'page10.pdf'},
    page11: { description: "Is there a need for energy revolution ", action: 'TemplatePage', template: 'page11.pdf'},
    page12: { description: "Climate change - all responsible", action: 'TemplatePage', template: 'page12.pdf'},
    page13: { description: "Consequences today-tomorrow", action: 'TemplatePage', template: 'page13.pdf'},
    page14: { description: "Doing our bit - we all win ", action: 'TemplatePage', template: 'page14.pdf'},
    page15: { description: "What can we do for you…", action: 'TemplatePage', template: 'page15.pdf'},
    page16: { description: "4 steps to lower bills ", action: 'TemplatePage', template: 'page16.pdf'},
    page17: { description: "Step 1 - solar panels", action: 'TemplatePage', template: 'page17.pdf'},
    page18: { description: "Solar Panels", action: 'TemplatePage', template: 'page18.pdf'},
    page19: { description: "Shading - no problem", action: 'TemplatePage', template: 'page19.pdf'},
    page20: { description: "pitched roof - flat roof….", action: 'TemplatePage', template: 'page20.pdf'},
    page21: { description: "Brain - Inverters", action: 'TemplatePage', template: 'page21.pdf'},
    page22: { description: "Top quality fittings/Installers", action: 'TemplatePage', template: 'page22.pdf'},
    page23: { description: "Bridge from solar to battery", action: 'TemplatePage', template: 'page23.pdf'},
    page24: { description: "Step 2 - batteries", action: 'TemplatePage', template: 'page24.pdf'},
    page25: { description: "Step 3 - Export ", action: 'TemplatePage', template: 'page25.pdf'},
    page26: { description: "Step 4 - Octopus", action: 'TemplatePage', template: 'page26.pdf'},
    page27: { description: "Power of solar & battery", action: 'TemplatePage', template: 'page27.pdf'},
    page28: { description: "Want to see it all live", action: 'TemplatePage', template: 'page28.pdf'},
    page29: { description: "Want to save even more", action: 'TemplatePage', template: 'page29.pdf'},
    page30: { description: "Smart energy products", action: 'TemplatePage', template: 'page30.pdf'},
    page31: { description: "EV chargers", action: 'TemplatePage', template: 'page31.pdf'},
    page32: { description: "EPVS", action: 'TemplatePage', template: 'page32.pdf'},
    page33: { description: "HIES", action: 'TemplatePage', template: 'page33.pdf'},
    page34: { description: "Maintenance ", action: 'TemplatePage', template: 'page34.pdf'},
    page35: { description: "Time for your survey ", action: 'TemplatePage', template: 'page35.pdf'},
    page36: { description: "Everyday & Privileged price", action: 'TemplatePage', template: 'page36.pdf'},
    page37: { description: "7 day incentive price", action: 'TemplatePage', template: 'page37.pdf'},
    page38: { description: "Aurora Picture Pages" , action: 'AddPictures', template: 'empty', title: '', page: 'page38.pdf'},
    page39: {
        description: "Year 1 savings  - Field Everday price",
        action: 'MailMerge',
        filter: '(30) Everyday',
        template: "yr1_everyday30_savings.pdf",
        page: 'page39.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "yr1_batteryandsolar_benefit", pdf: "yr1_solar_battery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smartproduct_benefit", pdf: "yr1_smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "yr1_smartexport_benefit", pdf: "yr1_smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smarttariff_benefit", pdf: "yr1_smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_total", pdf: "yr1_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_bill_savings_text", pdf: "energy_bill_savings_percent", format: 'None', title: 'N'},
        ]
    },
    page40: {
        description: "Year 1 savings  - Field Privileged Price",
        action: 'MailMerge',
        filter: 'Privileged',
        template: "yr1_privileged_savings.pdf",
        page: 'page39.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "yr1_batteryandsolar_benefit", pdf: "yr1_solar_battery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smartproduct_benefit", pdf: "yr1_smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "yr1_smartexport_benefit", pdf: "yr1_smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smarttariff_benefit", pdf: "yr1_smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_total", pdf: "yr1_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_bill_savings_text", pdf: "energy_bill_savings_percent", format: 'None', title: 'N'},
        ]
    },    
    page41: {
        description: "Year 1 savings  - 7 Day Off Phone Price",
        action: 'MailMerge',
        filter: '7 Day Offer',
        template: "yr1_7day_savings.pdf",
        page: 'page39.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "yr1_batteryandsolar_benefit", pdf: "yr1_solar_battery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smartproduct_benefit", pdf: "yr1_smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "yr1_smartexport_benefit", pdf: "yr1_smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smarttariff_benefit", pdf: "yr1_smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_total", pdf: "yr1_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_bill_savings_text", pdf: "energy_bill_savings_percent", format: 'None', title: 'N'},
        ]
    },
    page42: {
        description: "Year 1 savings  - Everyday Offer Phone Price",
        action: 'MailMerge',
        filter: 'Everyday',
        template: "yr1_everyday_phone_savings.pdf",
        page: 'page39.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "yr1_batteryandsolar_benefit", pdf: "yr1_solar_battery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smartproduct_benefit", pdf: "yr1_smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "yr1_smartexport_benefit", pdf: "yr1_smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_smarttariff_benefit", pdf: "yr1_smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_total", pdf: "yr1_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "yr1_bill_savings_text", pdf: "energy_bill_savings_percent", format: 'None', title: 'N'},
        ]
    },    
    page43: {
        description: "Year Average Annual [XX] Projected Savings - Every Day 30 Price",
        action: 'MailMerge',
        filter: '(30) Everyday',
        template: "average_annual_xyr_savings.pdf",
        title: "‘Everyday (30 day) Price’",
        page: 'page40.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "calcterm", pdf: "price_header", format: 'None', title: 'Y'},
            { index:  null, state:  "calcterm", pdf: "xyears_heading", format: 'None', title: 'N'},
            { index:  null, state:  "avg_batteryandsolar_benefit", pdf: "solarbattery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smartproduct_benefit", pdf: "smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "avg_smartexport_benefit", pdf: "smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smarttariff_benefit", pdf: "smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_total", pdf: "annual_average_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "average_annual_roi_30", pdf: "average_annual_roi", format: 'None', title: 'N'},
        ]
    },
    page44: {
        description: "Year Average Annual [XX] Projected Savings - ‘Privileged Price",
        action: 'MailMerge',
        filter: 'Privileged',
        template: "average_annual_xyr_savings.pdf",
        title: "‘Privileged Price’",
        page: 'page40.pdf',
        font: "fredokaone",        
        fields: [
            { index:  null, state:  "calcterm", pdf: "price_header", format: 'None', title: 'Y'},
            { index:  null, state:  "calcterm", pdf: "xyears_heading", format: 'None', title: 'N'},
            { index:  null, state:  "avg_batteryandsolar_benefit", pdf: "solarbattery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smartproduct_benefit", pdf: "smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "avg_smartexport_benefit", pdf: "smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smarttariff_benefit", pdf: "smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_total", pdf: "annual_average_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "average_annual_roi_priv", pdf: "average_annual_roi", format: 'None', title: 'N'},
        ]
    },      
    page45: {
        description: "Year Average Annual [XX] Projected Savings - 7 Day Price",
        filter: '7 Day Offer',
        action: 'MailMerge',
        template: "average_annual_xyr_savings.pdf",
        title: "‘7 Day Offer’",
        page: 'page40.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "calcterm", pdf: "price_header", format: 'None', title: 'Y'},
            { index:  null, state:  "calcterm", pdf: "xyears_heading", format: 'None', title: 'N'},
            { index:  null, state:  "avg_batteryandsolar_benefit", pdf: "solarbattery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smartproduct_benefit", pdf: "smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "avg_smartexport_benefit", pdf: "smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smarttariff_benefit", pdf: "smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_total", pdf: "annual_average_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "average_annual_roi_7day", pdf: "average_annual_roi", format: 'None', title: 'N'},
        ]
    },    
     
    page46: {
        description: "Year Average Annual [XX] Projected Savings - 7 Day Price",
        filter: 'Everyday',
        action: 'MailMerge',
        template: "average_annual_xyr_savings.pdf",
        title: "‘Everyday Price’",
        page: 'page40.pdf',
        font: "fredokaone",
        fields: [
            { index:  null, state:  "calcterm", pdf: "price_header", format: 'None', title: 'Y'},
            { index:  null, state:  "calcterm", pdf: "xyears_heading", format: 'None', title: 'N'},
            { index:  null, state:  "avg_batteryandsolar_benefit", pdf: "solarbattery_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smartproduct_benefit", pdf: "smart_products_benefits", format: 'Currency', title: 'N' },
            { index:  null, state:  "avg_smartexport_benefit", pdf: "smart_export_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_smarttariff_benefit", pdf: "smart_energy_benefits", format: 'Currency', title: 'N'},
            { index:  null, state:  "avg_total", pdf: "annual_average_benefit", format: 'Currency', title: 'N'},
            { index:  null, state:  "average_annual_roi_7day", pdf: "average_annual_roi", format: 'None', title: 'N'},
        ]
    },    

    page47: {
        description: "With & Without Solar",
        title: "With & Without Solar",
        action: 'MailMerge',
        template: "with_without_solar.pdf",
        page: 'page41.pdf',
        font: "fredokaone",
        fields:[
            { index:  null, state:  "average_monthly_with_solar", pdf: "average_monthly_with_solar", format: 'Currency', title: 'N'},
            { index:  null, state:  "average_monthly_without_solar", pdf: "average_monthly_without_solar", format: 'Currency', title: 'N'},
            { index:  null, state:  "average_xyears_with_solar", pdf: "average_xyears_with_solar", format: 'Currency', title: 'N'},
            { index:  null, state:  "with_xyears_time", pdf: "with_xyears_time", format: 'None', title: 'N', font: 'feltthat'},
            { index:  null, state:  "average_xyears_without_solar", pdf: "average_xyears_without_solar", format: 'Currency', title: 'N'},
            { index:  null, state:  "without_xyears_time", pdf: "without_xyears_time", format: 'None', title: 'N', font: 'feltthat'}
        ]
    },

    page48: {
        description: "What you get - Everyday 30 price",
        title: "Your Everyday (30 day) Price",
        action: 'MailMerge',
        filter: '(30) Everyday',
        template: "loving_returns.pdf",
        page: "page42.pdf",        
        font: "opensans",
        fields:[
            { index:  null, state:  "your_price_heading", pdf: "your_price_heading", format: 'None', title: 'Y'},
            { index:  0, state:  "line_items", pdf: "line1", format: 'None', title: 'N'},
            { index:  1, state:  "line_items", pdf: "line2", format: 'None', title: 'N'},
            { index:  2, state:  "line_items", pdf: "line3", format: 'None', title: 'N'},
            { index:  3, state:  "line_items", pdf: "line4", format: 'None', title: 'N'},
            { index:  4, state:  "line_items", pdf: "line5", format: 'None', title: 'N'},
            { index:  5, state:  "line_items", pdf: "line6", format: 'None', title: 'N'},
            { index:  6, state:  "line_items", pdf: "line7", format: 'None', title: 'N'},
            { index:  7, state:  "line_items", pdf: "line8", format: 'None', title: 'N'},
            { index:  8, state:  "line_items", pdf: "line9", format: 'None', title: 'N'},
            { index:  9, state:  "line_items", pdf: "line10", format: 'None', title: 'N'},
            { index:  10, state:  "line_items", pdf: "line11", format: 'None', title: 'N'},
            { index:  11, state:  "line_items", pdf: "line12", format: 'None', title: 'N'},
            { index:  12, state:  "line_items", pdf: "line13", format: 'None', title: 'N'},
            { index:  13, state:  "line_items", pdf: "line14", format: 'None', title: 'N'},
            { index:  14, state:  "line_items", pdf: "line15", format: 'None', title: 'N'},
            { index:  15, state:  "line_items", pdf: "line16", format: 'None', title: 'N'},
            { index:  null, state:  "system_cost_30day", pdf: "your_system_cost", format: 'Currency', title: 'N'},

        ]
    },
    page49: {
        description: "What you get -  Priviledged price",
        title: "Your Privileged Price",  
        action: 'MailMerge',   
        filter: 'Privileged',
        template: "loving_returns.pdf",
        page: "page42.pdf",
        font: "opensans",
        fields:[
            { index:  null, state:  "your_price_heading", pdf: "your_price_heading", format: 'None', title: "Y"},
            { index:  0, state:  "line_items", pdf: "line1", format: 'None', title: 'N'},
            { index:  1, state:  "line_items", pdf: "line2", format: 'None', title: 'N'},
            { index:  2, state:  "line_items", pdf: "line3", format: 'None', title: 'N'},
            { index:  3, state:  "line_items", pdf: "line4", format: 'None', title: 'N'},
            { index:  4, state:  "line_items", pdf: "line5", format: 'None', title: 'N'},
            { index:  5, state:  "line_items", pdf: "line6", format: 'None', title: 'N'},
            { index:  6, state:  "line_items", pdf: "line7", format: 'None', title: 'N'},
            { index:  7, state:  "line_items", pdf: "line8", format: 'None', title: 'N'},
            { index:  8, state:  "line_items", pdf: "line9", format: 'None', title: 'N'},
            { index:  9, state:  "line_items", pdf: "line10", format: 'None', title: 'N'},
            { index:  10, state:  "line_items", pdf: "line11", format: 'None', title: 'N'},
            { index:  11, state:  "line_items", pdf: "line12", format: 'None', title: 'N'},
            { index:  12, state:  "line_items", pdf: "line13", format: 'None', title: 'N'},
            { index:  13, state:  "line_items", pdf: "line14", format: 'None', title: 'N'},
            { index:  14, state:  "line_items", pdf: "line15", format: 'None', title: 'N'},
            { index:  15, state:  "line_items", pdf: "line16", format: 'None', title: 'N'},
            { index:  null, state:  "system_cost_privilege", pdf: "your_system_cost", format: 'Currency'},

        ]
    },
    page50: {
        description: "What you get - 7 Day Inscentive Price",
        title: "Your 7 Day Offer Incentive",
        action: 'MailMerge',
        filter: '7 Day Offer',
        template: "loving_returns.pdf",
        font: "opensans",
        page: "page42.pdf",
        fields:[
            { index:  null, state:  "your_price_heading", pdf: "your_price_heading", format: 'None', title: 'Y'},
            { index:  0, state:  "line_items", pdf: "line1", format: 'None', title: 'N'},
            { index:  1, state:  "line_items", pdf: "line2", format: 'None', title: 'N'},
            { index:  2, state:  "line_items", pdf: "line3", format: 'None', title: 'N'},
            { index:  3, state:  "line_items", pdf: "line4", format: 'None', title: 'N'},
            { index:  4, state:  "line_items", pdf: "line5", format: 'None', title: 'N'},
            { index:  5, state:  "line_items", pdf: "line6", format: 'None', title: 'N'},
            { index:  6, state:  "line_items", pdf: "line7", format: 'None', title: 'N'},
            { index:  7, state:  "line_items", pdf: "line8", format: 'None', title: 'N'},
            { index:  8, state:  "line_items", pdf: "line9", format: 'None', title: 'N'},
            { index:  9, state:  "line_items", pdf: "line10", format: 'None', title: 'N'},
            { index:  10, state:  "line_items", pdf: "line11", format: 'None', title: 'N'},
            { index:  11, state:  "line_items", pdf: "line12", format: 'None', title: 'N'},
            { index:  12, state:  "line_items", pdf: "line13", format: 'None', title: 'N'},
            { index:  13, state:  "line_items", pdf: "line14", format: 'None', title: 'N'},
            { index:  14, state:  "line_items", pdf: "line15", format: 'None', title: 'N'},
            { index:  15, state:  "line_items", pdf: "line16", format: 'None', title: 'N'},
            { index:  null, state:  "system_cost_7day", pdf: "your_system_cost", format: 'Currency', title: 'N'},
        ]
    },
    page51: {
        description: "What you get - 7 Day Inscentive Price",
        title: "Your Everyday Price",
        action: 'MailMerge',
        filter: 'Everyday',
        template: "loving_returns.pdf",
        font: "opensans",
        page: 'page42.pdf',
        fields:[
            { index:  null, state:  "your_price_heading", pdf: "your_price_heading", format: 'None', title: 'Y'},
            { index:  0, state:  "line_items", pdf: "line1", format: 'None', title: 'N'},
            { index:  1, state:  "line_items", pdf: "line2", format: 'None', title: 'N'},
            { index:  2, state:  "line_items", pdf: "line3", format: 'None', title: 'N'},
            { index:  3, state:  "line_items", pdf: "line4", format: 'None', title: 'N'},
            { index:  4, state:  "line_items", pdf: "line5", format: 'None', title: 'N'},
            { index:  5, state:  "line_items", pdf: "line6", format: 'None', title: 'N'},
            { index:  6, state:  "line_items", pdf: "line7", format: 'None', title: 'N'},
            { index:  7, state:  "line_items", pdf: "line8", format: 'None', title: 'N'},
            { index:  8, state:  "line_items", pdf: "line9", format: 'None', title: 'N'},
            { index:  9, state:  "line_items", pdf: "line10", format: 'None', title: 'N'},
            { index:  10, state:  "line_items", pdf: "line11", format: 'None', title: 'N'},
            { index:  11, state:  "line_items", pdf: "line12", format: 'None', title: 'N'},
            { index:  12, state:  "line_items", pdf: "line13", format: 'None', title: 'N'},
            { index:  13, state:  "line_items", pdf: "line14", format: 'None', title: 'N'},
            { index:  14, state:  "line_items", pdf: "line15", format: 'None', title: 'N'},
            { index:  15, state:  "line_items", pdf: "line16", format: 'None', title: 'N'},
            { index:  null, state:  "system_cost_7day", pdf: "your_system_cost", format: 'Currency', title: 'N'},
        ]
    },
    page52: { description: "Summary - happy", action: 'TemplatePage', template: 'page43.pdf'},
    page53: {
        page: 'page44.pdf',
        description: "XX year projected savings table ",
        action: 'CreateDataTables',       
        fields:[
            { index:  null, state:  "", pdf: "", format: 'None', title: 'N'},
        ]
    },    
    page54: { description: "Help us to help you", action: 'TemplatePage', template: 'page45.pdf'},
    page55: { description: "Next steps", action: 'TemplatePage', template: 'page46.pdf'},
    page56: { description: "Thank You", action: 'TemplatePage', template: 'page47.pdf'},
    num_slides: 56
}
